import { ERegistrationType } from "./person.enum";
import { EGenderType } from "./person.interface";

export const genderText: Record<EGenderType, string> = {
    [EGenderType.Male]: 'PERSON.GENERAL.SEXES.MALE',
    [EGenderType.Female]: 'PERSON.GENERAL.SEXES.FEMALE',
    [EGenderType.Others]: 'PERSON.GENERAL.SEXES.OTHERS',
}


/**
 * Gets the info label for a registration type.
 * @param registrationType - The registration type
 * @returns Translation key for the info label
 */
 export function getPersonTranslation(registrationType: ERegistrationType): string {
    switch (registrationType) {
      case ERegistrationType.Customer:
        return 'PERSON.TYPES.CUSTOMER';
      case ERegistrationType.Visitor:
        return 'PERSON.TYPES.VISITOR';
      case ERegistrationType.User:
        return 'PERSON.TYPES.USER';
    case ERegistrationType.Contact:
        return 'PERSON.TYPES.CONTACT';
      default:
        return '';
    }
  }